import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import { Colors } from '../../consts/Colors.js';


export default class Chapitre5_1 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre5_1"
        })
    }

    init(data){
        this.audioName = 'RewardsOfRisk';
        super.init(data);   
        this.chutAdded = false;
    }

    create(){
        super.create();
        this.animIn(() => {this.displayButtons();} );        
    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "bigboss"){
            this.openIndice(id);
            this.popup.textElmt.setWordWrapWidth(this.popup.background.width - 80)
            this.popup.textElmt.setFontSize('22px')
            this.popup.textElmt.setLineSpacing(-3)
        }
    }

    closePopup(){
        let allViewed = true;
        this.buttons.forEach( (btn) => {
            if(!btn.isViewed){
                allViewed = false;
            }
        })

        if(allViewed){
            if(!this.chutAdded){
                this.addChutBouton();
            }else{
                this.animOut();
            }
        }

        super.closePopup();
    }

    addChutBouton(){
        this.chutAdded = true;

        let data = this.config.chut
        this.config.boutons.push(data)

        let button = new ButtonDecor(this, data.position.x, data.position.y, 3)
        button.setAlpha(0)
        if(this.chapitreProgression.boutonsDecors[3] == 1){
            button.setViewed();
        }
        this.buttons.push(button)

        button.setClickFunction( (btnInstance) => {
            if(!btnInstance.isViewed){
                btnInstance.setViewed();
                this.chapitreProgression.boutonsDecors[btnInstance.id] = 1;
                this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
            }

            this.openIndice( btnInstance.id );
        } )
    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre5_2")
            }
        })
    }

    animIn(endFunction){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                if(endFunction){
                    endFunction();
                }
            }
        })
    }

}